import type { LightboxRevampData } from "~/clientState/hooks/model/lighboxContract";
import lightboxBenefitsData from "~/clientState/hooks/data/lightboxBenefits";

const useLightboxRevampData = (): LightboxRevampData => {
  return { data: lightboxBenefitsData };
};

export default useLightboxRevampData;
